import React from 'react';
import cx from 'classnames';

import styles from './PadMarginCenter.module.scss';
import usePresenter from './PadMarginCenter.presenter';
import getProps from './PadMarginCenter.props';
import { PadMarginCenterCombinedProps } from './types';

const PadMarginCenter: React.FC<PadMarginCenterCombinedProps> = (props) => {
  const {
    className,
    classes,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.padMarginCenter;

  return (
    <div className={cx(currentStyle, className)} />
  );
};

export default PadMarginCenter;
